// extracted by mini-css-extract-plugin
export default {"root":"Account_root__WSCH8","title":"Account_title__PA2qd","welcome":"Account_welcome__YanKL","link":"Account_link__K1ULR"};